import { CountryCode } from '@ev-tech/search-modules-api';

import { type ListingDataTranslationKey } from './types';

export const ROOMS_PRIMARY_COUNTRIES: ReadonlySet<CountryCode> = new Set([
  CountryCode.AT,
  CountryCode.CH,
  CountryCode.CZ,
  CountryCode.DE,
  CountryCode.DK,
  CountryCode.HR,
  CountryCode.HU,
  CountryCode.IT,
  CountryCode.LI,
  CountryCode.NL,
  CountryCode.PL,
]);

export const ENERGY_CERTIFICATE_INFO_VALUES = new Set(['usingeigenvalue', 'enddemand', 'usage', 'demand']);
export const ENERGY_UNIT_KEY: ListingDataTranslationKey = 'search.listingData.energy.label.measurementUnit';
export const CO2_EMISSION_UNIT_KEY: ListingDataTranslationKey = 'search.listingData.energy.label.co2EmissionUnit';
export const EPC_UNIT = 'kWh/m²';
